import { render, staticRenderFns } from "./crowdChart.vue?vue&type=template&id=f51278be&scoped=true"
import script from "./crowdChart.vue?vue&type=script&lang=js"
export * from "./crowdChart.vue?vue&type=script&lang=js"
import style0 from "./crowdChart.vue?vue&type=style&index=0&id=f51278be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51278be",
  null
  
)

export default component.exports